import type { RuleStatus } from '../types';
import { useI18n } from '../i18n';

interface StatusBadgeProps {
  readonly status: RuleStatus;
}

function statusClass(status: RuleStatus): string {
  return status.toLowerCase().replaceAll(' ', '-');
}

const STATUS_KEYS: Readonly<Record<RuleStatus, string>> = {
  Active: 'status.active',
  Matched: 'status.matched',
  Unmatched: 'status.unmatched',
  Overridden: 'status.overridden',
  'Blocked negation': 'status.blockedNegation',
  'Broad rule': 'status.broadRule',
  Comment: 'status.comment',
  Blank: 'status.blank',
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const { t } = useI18n();
  return (
    <span className={`status-badge status-${statusClass(status)}`}>{t(STATUS_KEYS[status])}</span>
  );
}
